import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import HelpdeskTipoChamado from "model/helpdesk/HelpdeskTipoChamado";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import HelpdeskTipoChamadoService from "service/helpdesk/HelpdeskTipoChamadoService";

const helpdeskTipoChamadoService = new HelpdeskTipoChamadoService();

export default function HelpdeskTipoChamadoCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, clearErrors, setError, setFocus, register, formState: {errors}} = useForm();

    const [helpdeskTipoChamado, setHelpdeskTipoChamado] = useState<HelpdeskTipoChamado>(new HelpdeskTipoChamado());
    const [titulo, setTitulo] = useState<string>('Tipo Chamado do Helpdesk');
    const [editando, setEditando] = useState<boolean>(false);

    const inputNomeRef = useRef<any>(null);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }
    },[])

    function validar() {

       if (!helpdeskTipoChamado.descricao) {
            setError("nome", {type: "manual", message: "Nome é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={helpdeskTipoChamado} novoCadastro getNewModel={()=>new HelpdeskTipoChamado()} service={helpdeskTipoChamadoService} setModel={(value: HelpdeskTipoChamado) => setHelpdeskTipoChamado(value)} validar={() => validar()} urlService="/helpdeskTipoChamado" pathCadastro="/helpdeskTipoChamado" tituloPagina={'Helpdesk Tipo Chamado'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={helpdeskTipoChamado.compra}
                    onChange={(e) => setHelpdeskTipoChamado({ ...helpdeskTipoChamado, compra: e.target.checked as boolean })}
                    style={{ marginRight: 5 }} />
                <label>Compra</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Descrição</Label>
                <div className="col-sm-12">
                    <InputText 
                        required value={helpdeskTipoChamado.descricao}
                        className={errors.descricao ? "p-invalid" : ""} 
                        style={{ width: '100%' }}
                        {...register("descricao", {
                            onChange: (e) => {
                                setHelpdeskTipoChamado({ ...helpdeskTipoChamado, descricao: e.target.value })
                                clearErrors("descricao")
                            }
                        })}
                    />
                </div>
                {errors.descricao && errors.descricao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.descricao?.message as string}</span> : null}
            </div>
        </BaseCadastro>
    )
}